import { render, staticRenderFns } from "./wxfaceresult.vue?vue&type=template&id=df4281d8&scoped=true&"
import script from "./wxfaceresult.vue?vue&type=script&lang=js&"
export * from "./wxfaceresult.vue?vue&type=script&lang=js&"
import style0 from "./wxfaceresult.vue?vue&type=style&index=0&id=df4281d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4281d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df4281d8')) {
      api.createRecord('df4281d8', component.options)
    } else {
      api.reload('df4281d8', component.options)
    }
    module.hot.accept("./wxfaceresult.vue?vue&type=template&id=df4281d8&scoped=true&", function () {
      api.rerender('df4281d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxfaceresult.vue"
export default component.exports